<template>
  <div class="main-search">
    <form style="padding: 0 1.5vw;background:#fff;height: 15vw;" action="/">
      <van-icon name="arrow-left" @click="clickBack" />
      <van-search
        v-model="content"
        placeholder="请输入搜索关键词"
        show-action
        shape="round"
        @search="onSearch"
        class="searchHead"
      >
        <div slot="action">
          <div @click="onSearch(content)">搜索</div>
        </div>
      </van-search>
    </form>
    <van-dropdown-menu>
      <van-dropdown-item
        ref="items"
        v-model="dropDown.drop1.value"
        :options="dropDown.drop1.options"
      />
      <van-dropdown-item
        v-model="dropDown.drop2.value"
        :options="dropDown.drop2.options"
        @change="clickChange"
      />
    </van-dropdown-menu>
    <div v-if="newsarr.length > 0" class="scroll">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        style="height: calc(100% - 24.2vw); overflow: auto"
      >
        <van-list v-model="loading" :finished="finished" finished-text="到底啦~" @load="onLoad">
          <div v-if="showEmpty" class="isAllGrid">
            <van-grid :column-num="2" gutter="1.5vw" class="searchGrid" v-show="isGridShow">
              <van-grid-item
                v-for="data in newsarr"
                :key="data.id"
                class="searchArr"
                @click="handleSearchClick(data.code)"
              >
                <van-image :src="data.pictureUrl" style="width:40vw;height:26vw" />
                <div class="searchName">{{data.name}}</div>
                <div class="searchPri">￥{{data.price}}</div>
              </van-grid-item>
            </van-grid>
            <van-grid :column-num="1" gutter="1.5vw" class="searchGrid" v-show="!isGridShow">
              <van-grid-item
                v-for="data in newsarr"
                :key="data.id"
                class="searchArr"
                @click="handleSearchClick(data.code)"
              >
                <div style="display:flex;">
                  <van-image :src="data.pictureUrl" style="width:40vw;height:26vw" />
                  <div class="searchName">
                    <div>{{data.name}}</div>
                    <div class="searchPri">￥{{data.price}}</div>
                  </div>
                </div>
              </van-grid-item>
            </van-grid>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div v-else class="index-empty">
      <div class="imageEmptySearch">
        <img src="../../../assets/images/search.png" alt />
      </div>商家很懒，没有任何商品
    </div>
  </div>
</template>
<script>
import {
  Search,
  Tag,
  Icon,
  DropdownMenu,
  DropdownItem,
  Button,
  Grid,
  GridItem,
  Image,
  Toast,
  Dialog,
  List,
  PullRefresh
} from "vant";
import service from "../../api/goods/index";
export default {
  components: {
    [Search.name]: Search,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      showEmpty: true,
      content: "",
      tagList: [],
      hotList: ["女", "卫生巾", "夜用"],
      show: {
        primary: true,
        success: true
      },
      isShowTitle: false,
      tabData: [],
      active: 0,
      loading: false,
      isShow: true,
      dropDown: {
        drop1: {
          value: 0,
          options: [
            { text: "综合排序", value: 0 },
            { text: "销量排序", value: 1 },
            { text: "价格排序", value: 2 }
          ]
        },
        drop2: {
          value: "a",
          options: [
            { text: "列表展示", value: "a" },
            { text: "格子展示", value: 1 }
          ]
        }
      },
      newsarr: [],
      isGridShow: false,
      isColor: false,
      page: 1,
      pageSize: 10,
      IsSort: 0,
      finished: false,
      refreshing: false,
      firstLoading: false
    };
  },
  created() {
    let searchLog = JSON.parse(localStorage.getItem("searchLog"));
    this.tagList = searchLog == null ? [] : searchLog;
    this.content = this.$route.query.value;
    this.init(this.$route.query.value);
  },
  methods: {
    clickChange() {
      this.isGridShow = !this.isGridShow;
    },
    init(content) {
      this.getSearchList().then(searchlist => {
        if (searchlist.length !== 0) {  
        this.newsarr = searchlist;
        }else{
          this.newsarr = []
        }
        this.loading = false;
        if (searchlist.length < 10) {
          this.finished = true;
        }
      });
    },
    onLoad() {
      if(this.newsarr.length>10){
        this.page++;
        this.getSearchList().then(searchlist => {
          this.newsarr = this.newsarr.concat(searchlist);
        this.loading = false;
        if (searchlist.length < 10) {
          this.finished = true;
        }
      });
      }
      
    },
    onRefresh() {
      // 清空列表数据
      this.page = 1;
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.newsarr = [];
      this.getSearchList().then(searchlist => {
        if (searchlist.length !== 0) {  
        this.newsarr = searchlist;
        }else{
          this.newsarr = []
        }
        if (searchlist.length < 10) {
          this.finished = true;
          this.loading = false;
        }
        //
        this.refreshing = true;
        this.onLoad();
      });
    },
    onSearch(content) {
      this.content = content;
      this.page = 1;
      service
        .getByName(content, this.page, 10)
        .then(response => {
          this.newsarr = response.data;
        })
        .catch(error => {
          if (error.status == 404) {
            this.showEmpty = false;
          }
        });
      this.isShow = false;
      let searchLog = JSON.parse(localStorage.getItem("searchLog"));
      if (content !== "") {
        if (searchLog !== null) {
          let arr = [];
          arr.push(content);
          searchLog.map(keyWords => {
            arr.push(keyWords);
          });
          let newArr = Array.from(new Set(arr)).slice(0, 20);
          this.tagList = newArr;
          localStorage.setItem("searchLog", JSON.stringify(newArr));
        } else {
          localStorage.setItem("searchLog", JSON.stringify([content]));
          this.tagList.push(content);
        }
      }
    },
    getSearchList() {
      return new Promise((resolve, reject) => {
        service
          .getByName(this.content, this.page, this.pageSize)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject();
          });
      });
    },
    clickBack() {
      this.$router.go(-1);
    },
    handleSearchClick(Id) {
      this.$router.push({ name: "goods", query: { code: Id } });
    },
    // handleClick() {
    //   this.isGridShow = !this.isGridShow;
    // },
    onConfirm() {
      this.$refs.items.toggle();
    }
  }
};
</script>
<style lang="less" scoped>

.search {
  &-head {
    width: 100vw;
  }
}
.scroll{
  height:100%;
}
// .index-empty {
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   margin-top: 20vw;
// }

</style>